















import { Vue, Component } from 'vue-property-decorator'
import BaseEnroll from './components/common/BaseEnroll.vue'
import TaiwanEnrollForm from './components/taiwan/TaiwanBaseEnrollForm.vue'

import { ConfigStore } from '@/store/config'
import {
  fetchTaiwanStudentEnroll,
  updateTaiwanStudentEnroll,
  createTaiwanStudentEnroll
} from '@/apis/enroll/taiwanEnroll'
import { TaiwanEnroll } from '@/models/enrolls/taiwanEnroll'
import { confirm } from '@/utils/notification'

const createAjaxHandler: (
  ajax: typeof createTaiwanStudentEnroll | typeof updateTaiwanStudentEnroll
) =>
  | typeof createTaiwanStudentEnroll
  | typeof updateTaiwanStudentEnroll = ajax => async (form: TaiwanEnroll) => {
    const result = await ajax(form)
    if (result.reportCardUrl) {
      await confirm('您已报名成功！', '台湾考生报名', { type: 'success' })
    } else {
      await confirm('保存成功，但尚未上传PDF材料！', '台湾考生报名', {
        type: 'warning'
      })
    }
    return result
  }

@Component({
  components: { BaseEnroll, TaiwanEnrollForm }
})
export default class TaiwanStudent extends Vue {
  ajaxFetch = fetchTaiwanStudentEnroll
  ajaxCreate = createAjaxHandler(createTaiwanStudentEnroll)
  ajaxUpdate = createAjaxHandler(updateTaiwanStudentEnroll)

  form: TaiwanEnroll = {
    studentId: '',
    name: '',
    sex: '',
    birthda: '',
    idCard: '',
    taiwanpassId: '',
    taiwanIdCard: '',
    nowSchool: '',
    photoUrl: '',
    nation: '',
    address: '',
    phoneNumber: '',
    mobilPhone: '',
    email: '',
    faxNumber: '',
    firstVolunteer: '',
    secondVolunteer: '',
    thirdVolunteer: '',
    adjustAgree: '',
    school1: '',
    school1Location: '',
    school1StartTime: '',
    school1EndTime: '',
    school1EducationLevel: '',
    school2: '',
    school2Location: '',
    school2StartTime: '',
    school2EndTime: '',
    school2EducationLevel: '',
    school3: '',
    school3Location: '',
    school3StartTime: '',
    school3EndTime: '',
    school3EducationLevel: '',
    registraNo: '',
    candidateNo: '',
    chineseGrade: '',
    chineseLevel: '',
    mathGrade: '',
    mathLevel: '',
    engGrade: '',
    englevel: '',
    socialGrade: '',
    socialLevel: '',
    natureGrade: '',
    natureLevel: '',
    reportCardUrl: '',
    date1: '',
    awardDetails1: '',
    date2: '',
    awardDetails2: '',
    date3: '',
    awardDetails3: '',
    date4: '',
    awardDetails4: '',
    activity1: '',
    activity1TimeRange: '',
    activity1useTime: '',
    activity1Remark: '',
    activity2: '',
    activity2TimeRange: '',
    activity2useTime: '',
    activity2Remark: '',
    activity3: '',
    activity3TimeRange: '',
    activity3useTime: '',
    activity3Remark: '',
    activity4: '',
    activity4TimeRange: '',
    activity4useTime: '',
    activity4Remark: '',
    activity5: '',
    activity5TimeRange: '',
    activity5useTime: '',
    activity5Remark: '',
    activity6: '',
    activity6TimeRange: '',
    activity6useTime: '',
    activity6Remark: '',
    person1: '',
    person1Relation: '',
    person1JobInfo: '',
    person1PhoneNum: '',
    person2: '',
    person2Relation: '',
    person2JobInfo: '',
    person2PhoneNum: '',
    person3: '',
    person3Relation: '',
    person3JobInfo: '',
    person3PhoneNum: '',
    emergencyContact: '',
    emergencyContactRelation: '',
    emergencyContactAddress: '',
    emergencyContactPhoneNumber: '',
    emergencyContactFaXnumber: '',
    emergencyContactEmail: '',
    personalRepresentation: ''
  }

  get config() {
    return (
      ConfigStore.configs.find(a => a.key === 'taiwan-student')?.value ?? {}
    )
  }
}
